var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('svg',{attrs:{"fill":_vm.color}},[_c('text',{attrs:{"text-anchor":"middle","x":_vm.x,"y":_vm.y + 5}},[_vm._v(_vm._s(_vm.letter))])])
}
var staticRenderFns = []

export { render, staticRenderFns }